import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { AccountService } from '../proxy/controlling/controllers/account.service';
import { CompanyCodeService } from '../proxy/controlling/controllers/company-code.service';
import { SapAccountGroupService } from '../proxy/controlling/controllers/sap-account-group.service';
import { SapAccountSubgroupService } from '../proxy/controlling/controllers/sap-account-subgroup.service';
import { AccountDetailService } from '../proxy/controlling/controllers/account-detail.service';
FieldBuilder.setNamespace('Controlling');

export const SAPACCOUNTCOMPANYCODE_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('accountId', 'Entity.Account', AccountService)
    .displayFromNested('account.name')
    .sortBy('account.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('companyCodeId', 'Entity.CompanyCode', CompanyCodeService)
    .displayFromNested('companyCode.name')
    .sortBy('companyCode.name')
    .build(),
  FieldBuilder.foreignKey('sapAccountGroupId', 'Entity.SapAccountGroup', SapAccountGroupService)
    .displayFromNested('sapAccountGroup.name')
    .sortBy('sapAccountGroup.name')
    .build(),
  FieldBuilder.foreignKey('sapAccountSubgroupId', 'Entity.SapAccountSubgroup', SapAccountSubgroupService)
    .displayFromNested('sapAccountSubgroup.name')
    .sortBy('sapAccountSubgroup.name')
    .build(),
  FieldBuilder.foreignKey('accountDetailId', 'Entity.AccountDetail', AccountDetailService)
    .displayFromNested('accountDetail.name')
    .sortBy('accountDetail.name')
    .build(),
];

export const SAPACCOUNTCOMPANYCODE_CONFIG = {
  entityName: 'SapAccountCompanyCode',
  localizationKey: 'Controlling::Entity.SapAccountCompanyCode',
  fields: SAPACCOUNTCOMPANYCODE_FIELDS,
  permission: 'ControllingSap.SapAccountCompanyCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
